import React from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';
import WizardChildren from '../../WizardChildren';
import HStack from '../../../../BaseModule/Components/HStack/HStack';

interface Props {
	item: Extract<
		WizardItem,
		{ type: WizardItemType.H_STACK | WizardItemType.CONTAINER }
	>;
	onSubmit: (values: object) => void;
}

const WizardHStack: React.FC<Props> = ({ item, onSubmit }) => {
	const settings = item.settings;
	const style: React.CSSProperties = {
		...(settings?.style ?? {}),
		gap: settings?.gap ?? '0px',
	};

	return (
		<HStack style={style}>
			{item.children.map(child => (
				<WizardChildren key={child.id} item={child} onSubmit={onSubmit} />
			))}
		</HStack>
	);
};

export default WizardHStack;
